export const BELGIAN = "be";
export const BULGARIAN = "bg";
export const CZECH = "cs";
export const DANISH = "da";
export const GERMAN = "de";
export const GERMAN_AUSTRIA = "de-AT";
export const GREEK = "el";
export const ENGLISH = "en";
export const ENGLISH_AUSTRALIA = "en-AU";
export const ENGLISH_CANADA = "en-CA";
export const ENGLISH_GB = "en-GB";
export const ENGLISH_INDIA = "en-IN";
export const ENGLISH_NEW_ZEALAND = "en-NZ";
export const ENGLISH_US = "en-US";
export const ENGLISH_SOUTH_AFRICA = "en-ZA";
export const SPANISH = "es";
export const FRENCH = "fr";
export const FRENCH_CANADA = "fr-CA";
export const FRENCH_SWITZERLAND = "fr-CH";
export const CROATIAN = "hr";
export const HUNGARIAN = "hu";
export const INDONESIAN = "id";
export const ITALIAN = "it";
export const ICELAND = "is";
export const LITHUANIA = "lt";
export const LATVIA = "lv";
export const MALAY = "ms";
export const DUTCH = "nl";
export const DUTCH_BELGIUM = "nl-BE";
export const NORWAY = "no";
export const POLISH = "pl";
export const PORTUGUESE = "pt";
export const PORTUGUESE_BRASIL = "pt-BR";
export const ROMANIAN = "ro";
export const RUSSIAN = "ru";
export const SLOVAK = "sk";
export const SERBIAN = "sr";
export const SERBIAN_LATIN = "sr-Latn";
export const SWEDISH = "sv";
export const CHINESE = "zh";
export const CHINESE_CHINA = "zh-CN";
export const CHINESE_TAIWAN = "zh-TW";

export const NAME_BULGARIAN = "Ð±ÑÌÐ»Ð³Ð°ÑÑÐºÐ¸";
export const NAME_CZECH = "ÄeÅ¡tina";
export const NAME_DANISH = "Dansk";
export const NAME_GERMAN = "Deutsch";
export const NAME_GERMAN_AUSTRIA = "Deutsch (Ãsterreich)";
export const NAME_GREEK = "ÎÎ»Î»Î·Î½Î¹ÎºÎ¬";
export const NAME_ENGLISH = "English";
export const NAME_ENGLISH_AUSTRALIA = "English (Australia)";
export const NAME_ENGLISH_CANADA = "English (Canada)";
export const NAME_ENGLISH_GB = "English (Great Britain)";
export const NAME_ENGLISH_INDIA = "English (India)";
export const NAME_ENGLISH_NEW_ZEALAND = "English (New Zaeland)";
export const NAME_ENGLISH_US = "English (USA)";
export const NAME_ENGLISH_SOUTH_AFRICA = "English (South Africa)";
export const NAME_SPANISH = "EspaÃ±ol";
export const NAME_FRENCH = "FranÃ§ais";
export const NAME_FRENCH_CANADA = "FranÃ§ais (Canada)";
export const NAME_FRENCH_SWITZERLAND = "FranÃ§ais (Suisse)";
export const NAME_CROATIAN = "Hrvatski";
export const NAME_HUNGARIAN = "Magyar";
export const NAME_INDONESIAN = "Bahasa Indonesia";
export const NAME_ICELAND = "Ãsland";
export const NAME_ITALIAN = "Italiano";
export const NAME_LITHUANIA = "LietuviÅ³";
export const NAME_LATVIA = "LatviÉÊu";
export const NAME_MALAY = "Melayu";
export const NAME_NORWAY = "BokmÃ¥l";
export const NAME_DUTCH = "Nederland";
export const NAME_DUTCH_BELGIUM = "Nederland (Belgie)";
export const NAME_POLISH = "Polski";
export const NAME_PORTUGUESE = "PortuguÃªs";
export const NAME_PORTUGUESE_BRASIL = "PortuguÃªs (Brasil)";
export const NAME_ROMANIAN = "Romana";
export const NAME_RUSSIAN = "Ð ÑÑÑÐºÐ¸Ð¹";
export const NAME_SLOVAK = "SlovenÄina";
export const NAME_SERBIAN = "Srpski";
export const NAME_SERBIAN_LATIN = "Srpski (Latinski)";
export const NAME_SWEDISH = "Sverige";
export const NAME_CHINESE = "ä¸­æ";
export const NAME_CHINESE_CHINA = "ä¸­æ (ä¸­å)";
export const NAME_CHINESE_TAIWAN = "ä¸­æ (å°ç£)";

export const NAME_UNKNOWN = "Unknown name";
